/**
 * Returns true when the current browser is running on macOS. Used to render
 * platform-appropriate keyboard shortcut hints (⌘ vs Ctrl, ⌥ vs Alt, etc.).
 */
export function isMac(): boolean {
  if (typeof navigator === 'undefined') return false;
  // navigator.platform is deprecated but still the most reliable signal we
  // have without userAgentData (which Safari doesn't expose).
  return /mac/i.test(navigator.platform);
}

/** "⌘" on mac, "Ctrl" elsewhere — for inline keyboard shortcut hints. */
export function modKeyLabel(): string {
  return isMac() ? '⌘' : 'Ctrl';
}
